import { Flex, Input, Text, Button, Loader } from '@fluentui/react-northstar'
import React, { useEffect, useState } from 'react'
import { activateLicense, getLicenseDetails, LicenseDetailsResponse, LicenseStatusEnum } from '../../apis/messageListApi';
import * as microsoftTeams from "@microsoft/teams-js";
import "./License.scss";
import CenterLoader from '../Utils/CenterLoader';

const packageJson = require('../../../package.json')


const License = () => {
    const unableToGetLicense = "Unable to get license.";
    const unableToActivateLicense = "Unable to activate license.";
    const [currentLicenseDetails, setCurrentLicenseDetails] = useState<LicenseDetailsResponse>();
    const [activationKey, setActivationKey] = useState<string | undefined>();
    const [globalError, setGlobalError] = useState<string | undefined>();
    const [errorMsgActivate, setErrorMsgActivate] = useState<string | undefined>();
    const [isLoading, setIsLoading] = useState<boolean>(false);

    function handleActivationKeyChange(event: any) {
        const key = event.target.value;
        setActivationKey(key);
    }

    function handleActivateLicense(event: any) {
        if (activationKey && activationKey.length > 0) {
            setIsLoading(true);
            activateLicense({ activationCode: activationKey })
                .then((result) => {
                    if (result && result.data.success) {
                        microsoftTeams.tasks.submitTask();
                    } else {
                        if (result && result.data.errorMessage) {
                            setErrorMsgActivate(result.data.errorMessage);
                        } else {
                            setErrorMsgActivate(unableToActivateLicense);
                        }
                    }
                })
                .catch(() => setErrorMsgActivate(unableToActivateLicense))
                .finally(() => setIsLoading(false));
        }
    }

    function fetchLicenseDetails() {
        getLicenseDetails()
            .then((result) => {
                if (!result || !result.data) {
                    return;
                }
                setCurrentLicenseDetails(result.data);
            })
            .catch(error => setGlobalError(unableToGetLicense))
            .finally(() => setIsLoading(false));
    }

    function buildTitle(licenseDetails: LicenseDetailsResponse) {
        if (licenseDetails.licenseStatus === LicenseStatusEnum.Expired) {
            return "License expired"
        }

        if (licenseDetails.isTrial) {
            return "Trial version";
        }

        return "Licensed version";
    }

    function buildDescription(licenseDetails: LicenseDetailsResponse) {
        let dateFormatted = "";
        const expDate = licenseDetails.expirationDate;
        if (expDate) {
            const date = new Date(expDate);
            dateFormatted = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
        }

        if (licenseDetails.licenseStatus === LicenseStatusEnum.Expired) {


            return `License expired at ${dateFormatted}`
        }

        if (licenseDetails.isTrial) {
            return "";
        }

        return `License valid until ${dateFormatted}`;
    }

    useEffect(() => {
        fetchLicenseDetails();
    }, []);

    if (globalError) {
        return <Text
            className="textDescription"
            content={globalError}
        ></Text>
    }

    if (!currentLicenseDetails || isLoading) {
        return <CenterLoader />
    }

    const title = buildTitle(currentLicenseDetails);
    const description = buildDescription(currentLicenseDetails);

    return (
        <Flex className="container" gap="gap.small" column>
            <Flex className="boxContainer" column>
                <Flex gap="gap.small">
                    <Text
                        className="title"
                        content={title}
                    ></Text>
                </Flex>
                <Flex style={{ marginTop: "10px" }} gap="gap.small">
                    <Text
                        className="textDescription"
                        content={description}
                    ></Text>
                </Flex>
                <Flex style={{ marginTop: "15px" }} gap="gap.small">
                    <Input
                        fluid
                        className="inputActivationKey"
                        type="text"
                        placeholder='LicenseKey'
                        onChange={(e: any) => handleActivationKeyChange(e)}
                    />
                </Flex>
                <Flex style={{ marginTop: "5px", marginRight: "5px" }} gap="gap.small" hAlign="end">
                    <Text
                        color='red'
                        className="textDescription"
                        content={errorMsgActivate}
                    ></Text>
                </Flex>
                <Flex style={{ marginTop: "5px" }} gap="gap.small" hAlign="end">
                    <Button
                        disabled={!activationKey}
                        className="activateBtn"
                        primary
                        content="Activate"
                        onClick={handleActivateLicense}
                    ></Button>
                </Flex>
            </Flex>
            <Flex hAlign='end' vAlign='end'>
                <Text className='version' disabled content={packageJson.version}></Text>
            </Flex>
        </Flex>
    )

}

export default License;